import withLink from 'hoc/withLink';
import { useBreakpointValueGS } from 'hooks/useBreakpointValueGS';
import { useMemo } from 'react';
import { View } from 'react-native';
import { calcHeightWithWidth, calcSizeForDevice } from 'utils/index';
import { Platform } from 'utils/platform';

import TitleCard from './TitleCard';

import FastImage from 'components/FastImage';

const MediumCard: React.FC<CardProps & { isRelated?: boolean; style?: object }> = ({
  uri,
  title,
  imgTitle,
  reference,
  style: restStyle,
  ...rest
}) => {
  const mediumCardAspectRatio = 3 / 4;
  const overrideBaseWidth = rest.override?.cardWidth?.base;
  const overrideXsWidth = rest.override?.cardWidth?.xs || rest.override?.cardWidth?.base;
  const overrideSmWidth = rest.override?.cardWidth?.sm || rest.override?.cardWidth?.base;
  const overrideLgWidth = rest.override?.cardWidth?.lg || rest.override?.cardWidth?.base;
  const overrideXlWidth = rest.override?.cardWidth?.xl || rest.override?.cardWidth?.base;

  const mediumCardWidth = useBreakpointValueGS({
    xl: overrideXlWidth || calcSizeForDevice(201, rest.isRelated ? 201 : 260),
    lg: overrideLgWidth || 189,
    sm: overrideSmWidth || (Platform.isAndroidTV ? 130 : 174),
    xs: overrideXsWidth || 135,
    base: overrideBaseWidth || 135,
  });

  const mediumCardHeight = useMemo(
    () => calcHeightWithWidth(mediumCardWidth ?? 135, mediumCardAspectRatio),
    [mediumCardWidth, mediumCardAspectRatio]
  );

  return (
    <View
      style={{
        width: mediumCardWidth,
        height: mediumCardHeight,
        borderRadius: 8,
        overflow: 'hidden',
        ...(restStyle || {}),
      }}
      {...rest}>
      {uri ? (
        <FastImage
          size="sm"
          aspect="3x4"
          source={{ uri }}
          style={{ width: '100%', height: '100%', borderRadius: 8, overflow: 'hidden' }}
        />
      ) : (
        <TitleCard title={title || imgTitle} reference={reference} />
      )}
    </View>
  );
};

export default withLink(MediumCard, 'MediumCard');
